import React from 'react';
import { Settings as SettingsIcon } from 'lucide-react';
import { SettingsTabs } from '../components/settings/SettingsTabs';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const Settings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = location.pathname.split('/')[2] || 'general';

  const handleTabChange = (tab: string) => {
    navigate(`/settings/${tab}`);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center space-x-3">
        <SettingsIcon className="h-8 w-8 text-blue-500" />
        <div>
          <h1 className="text-2xl font-bold text-white">Settings</h1>
          <p className="text-sm text-gray-400">Manage your account and application settings</p>
        </div>
      </div>

      {/* Settings Content */}
      <div className="grid grid-cols-12 gap-6">
        {/* Sidebar */}
        <div className="col-span-3">
          <SettingsTabs activeTab={activeTab} onTabChange={handleTabChange} />
        </div>

        {/* Main Content */}
        <div className="col-span-9">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Settings;